var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart-list"},[_c('Scroll',{ref:"scroll",staticClass:"wrapper",attrs:{"probe-type":0,"pull-up-load":true}},_vm._l((_vm.test),function(item){return _c('cart-list-item',{attrs:{"item":item}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }